import { defineMessages } from 'react-intl';

export default defineMessages({
  resetRecipe: {
    id: 'ordering.pdp.resetRecipe',
    defaultMessage: 'Reset to standard recipe',
    description: 'Clears customizations user has made to their item',
  },
});
